import {
  apiRequest,
  skpTunjanganKhususCreate,
  skpTunjanganKhususUpdate,
  employeeList,
  individualcriterialist,
  skppernipCreate,
  getposition
} from "../../../../../services/adapters/kepegawaian/skpTunjanganKhususService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      skpTunjanganKhususCreate,
      {
        body: query,
      },
      true
    );
  };
  
  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      skpTunjanganKhususUpdate,
      {
        body: query,
      },
      true
      );
    };
    
    fetchEmployee = async (query) => {
      return await apiRequest("get", employeeList, {
        params: query
      }, true)
    }
    fetchIndividualCriteria = async (query) => {
      return await apiRequest("get", individualcriterialist, {
        params: query
      }, true)
    }
    
    fetchCreatepernip = async (query) => {
      return await apiRequest(
        "post",
        skppernipCreate,
        {
          body: query,
        },
        true
        );
      };
      
      fetchPosition = async (query) => {
        return await apiRequest("get", getposition, {
          params: query
        }, true)
      }
}

export default CreateRepository;
